import { render, staticRenderFns } from "./LoanDetailsHeader.vue?vue&type=template&id=5fac00db"
import script from "./LoanDetailsHeader.vue?vue&type=script&lang=js"
export * from "./LoanDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports